import { Button, Divider, Form, Input, Select, Space } from 'antd'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { Icon } from '../../'
import { translations } from '../../../constants'
import { trimFields } from '../../../utils'

const selectOptions = [
  { label: 'CHECKING', value: 'CHECKING' },
  { label: 'SAVINGS', value: 'SAVINGS' },
]

const CaForm = ({
  hideModal,
  isFormNeedPaymentMethods = true,
  locale = 'us',
  onSubmit,
}) => {
  const [form] = Form.useForm()
  const [isModalLoading, setModalLoading] = useState(false)

  const handleSubmit = () => {
    const isFormUpdated = form.isFieldsTouched()
    if (isFormUpdated) {
      form
        .validateFields()
        .then(() => {
          setModalLoading(true)
          const requiredFieldsValue = trimFields(form.getFieldsValue())

          onSubmit({
            country: 'ca',
            requiredFieldsValue,
            setModalLoading,
          })
        })
    }
  }

  return (
    <Form
      data-test="bank-details-form"
      data-testid="caForm"
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
    >
      <Form.Item
        className="bankDetailsAccountNumber"
        label={translations[locale].accountNumber}
        name="accountNumber"
        rules={[
          {
            message: 'Please enter your account number!',
            required: true,
          },
          {
            max: 12,
            message: 'Account number must be between 7 and 12 digits!',
          },
          {
            message: 'Account number must be between 7 and 12 digits',
            min: 7,
          },
          {
            message: 'Account number can only contain numbers!',
            pattern: /^[0-9]+$/,
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        className="bankDetailsAccountType"
        label={translations[locale].accountType}
        name="accountType"
        rules={[
          {
            message: 'Please provide an account type!',
            required: true,
          },
        ]}
      >
        <Select options={selectOptions} placeholder="CHECKING" />
      </Form.Item>

      <Form.Item
        className="bankDetailsInstitutionNumber"
        label={translations[locale].institutionNumber}
        name="institutionNumber"
        rules={[
          {
            message: 'Please make sure your institution number is correct!',
            required: true,
          },
          {
            max: 3,
            message: 'Please enter a valid 3-digit institution number.',
          },
          {
            message: 'Please enter a valid 3-digit institution number.',
            min: 3,
          },
          {
            message: 'Institution number should contain only numbers!',
            pattern: /^[0-9]+$/,
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        className="bankDetailsTransitNumber"
        label={translations[locale].transitNumber}
        name="transitNumber"
        rules={[
          {
            message: 'Please make sure your transit number is correct!',
            required: true,
          },
          {
            max: 5,
            message: 'Please enter a valid 5-digit transit number.',
          },
          {
            message: 'Please enter a valid 5-digit transit number.',
            min: 5,
          },
          {
            message: 'Transit number should contain only numbers!',
            pattern: /^[0-9]+$/,
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={translations[locale].legalEntity}
        name="legal_entity"
        rules={[{ message: 'Please enter the Legal Entity!', required: true }]}
        tooltip={{ icon: <Icon type="infoCircle" />, title: translations[locale].legalEntityTooltip }}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={translations[locale].reportingEmail}
        name="reporting_email"
        rules={[
          {
            message: 'The input is not valid email!',
            type: 'email',
          },
          {
            message: 'Please provide a valid reporting email address!',
            required: true,
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Divider />

      <Space
        size="middle"
        style={{
          display: 'flex',
          justifyContent: 'end',
        }}
      >
        {isFormNeedPaymentMethods && <Button className="bankDetailsCancel" name="cancelBtnSelenium" onClick={hideModal}>Cancel</Button>}
        <Button className="bankDetailsSubmit" htmlType="submit" loading={isModalLoading} name="submitBtnSelenium" type="primary">{translations[locale].submit}</Button>
      </Space>
    </Form>
  )
}

CaForm.propTypes = {
  hideModal: PropTypes.func,
  isFormNeedPaymentMethods: PropTypes.bool,
  locale: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  selectedStore: PropTypes.object.isRequired,
}

export default CaForm
